// Firebase設定
import { initializeApp } from 'firebase/app'
import { getAuth, OAuthProvider, signInWithRedirect, getRedirectResult } from 'firebase/auth'

// Firebase設定（環境変数から取得）
const firebaseConfig = {
  apiKey: window.nurikae.apiKey,
  authDomain: window.nurikae.authDomain,
  projectId: window.nurikae.projectId,
  storageBucket: window.nurikae.storageBucket,
  messagingSenderId: window.nurikae.messagingSenderId,
  appId: window.nurikae.appId
}

// Firebase初期化
let app, auth, lineProvider

try {
  app = initializeApp(firebaseConfig)
  auth = getAuth(app)

  // LINE OIDCプロバイダー設定
  lineProvider = new OAuthProvider(`${window.nurikae.lineProvider}`)
  lineProvider.addScope('profile')
  lineProvider.addScope('openid')
  lineProvider.setCustomParameters({
    disable_auto_login: 'true' // Auto Loginを行うことでセッション情報が失われることがあるため追加
  })
} catch (error) {
  // モック用の空オブジェクト
  auth = null
  lineProvider = null
}

export { auth, lineProvider, signInWithRedirect, getRedirectResult }
